export default {
  'menu.welcome': 'Welcome',
  'menu.home': 'Home',
  'menu.blog': 'Blog',
  'menu.blog.authors': 'Authors',
  'menu.blog.authors_create': 'Create Author',
  'menu.blog.authors_edit': 'Edit Author',
  'menu.blog.topics': 'Topics',
  'menu.blog.topics_create': 'Create Topic',
  'menu.blog.topics_edit': 'Edit Topic',
  'menu.blog.articles': 'Articles',
  'menu.blog.articles_create': 'Create Article',
  'menu.blog.articles_edit': 'Edit Article',
};
